import { getStore } from '~/mobx/AppStore';
import { ZipCodeParser } from '~/utils/zipCodeParser';

const getZipcodeList = (): void => {
    const { zipcodeStore } = getStore();
    const firstRange = zipcodeStore.selectedZipcode.split(',')[0];
    const splitRanges = ZipCodeParser.splitLargeRange(firstRange);
    const rangeId = zipcodeStore.selectedRangeId || splitRanges[0];
    const selectedRange = ZipCodeParser.parse(rangeId)[0];
    const zipcodeList: string[] = [];

    if (selectedRange) {
        for (let zip = selectedRange.start; zip <= selectedRange.end; zip++) {
            const zipStr = String(zip).padStart(4, '0');
            zipcodeList.push(zipStr);
        }
    }

    zipcodeStore.setZipcodeList(zipcodeList);
};

export default getZipcodeList;
